export default "__VITE_ASSET__0f2f8cbc__"